<template>
  <ul class="list-disc ml-9">
    <li v-for="item in items" :key="item">{{item}}</li>
  </ul>
</template>

<script>
export default {
  name: "miniMarkedList",
  props: ['items']
}
</script>

<style scoped>

</style>